import React from 'react'

const RcsIcon = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <g
        stroke="#000"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2C7.373 2 2 7.373 2 14s5.373 12 12 12 12-5.373 12-12S20.627 2 14 2z" />
        <path d="M8 14h12M14 8v12" />
        <circle cx="14" cy="14" r="3" />
        <path d="M10 10l8 8M18 10l-8 8" />
      </g>
    </svg>
  )
}

export default RcsIcon


